// @flow
import styled from 'styled-components';

/* stylelint-disable */
/* eslint-disable */
export const Icon = styled.span`
  padding: 9px;
  border-right: 1px solid ${({ theme }) => theme.colors.uiM};
  margin-right: 12px;
  transition: all 0.25s ease;

  :hover,
  :focus {
    border-color: ${({ theme }) => theme.colors.accent1L};
  }

  svg {
    display: block;
    width: 24px;
    height: 24px;
  }
`;

export const Inner = styled.button`
  display: block;
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  border: 1px solid ${({ theme }) => theme.colors.ui};
  border-radius: 4px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 0.05);
  margin-bottom: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.terciaryD};
  text-align: center;
  text-align: left;
  transition: all 0.25s ease;

  :hover,
  :focus {
    border-color: ${({ theme }) => theme.colors.accent1L};
    box-shadow: 0 1px 2px rgb(23 113 251 / 0.2);
    color: ${({ theme }) => theme.colors.accent1};

    ${/* sc-prop */ Icon} {
      border-color: ${({ theme }) => theme.colors.accent1L};
    }
  }
`;

/* stylelint-enable */
/* eslint-enable */
